<template>
    <div>
        <div class="elasticsearchWarning-title">
        	<Breadcrumb>
                <BreadcrumbItem>{{this.$route.query.accountTypeName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.accountName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.name}}</BreadcrumbItem>
                <BreadcrumbItem to="/monitor/elasticsearchMonitor">Elastic Search</BreadcrumbItem>
                <BreadcrumbItem>
                    <a @click="ipAddress">{{ $t('alarms.common.alertRule') }}</a>
                </BreadcrumbItem>
            </Breadcrumb>
        </div>
        <template>
            <Tabs size="small" :animated="false">
                <TabPane :label="$t('alarms.common.alertRule')">
                    <div class="elasticsearchWarning-top">
                        <elasticsearch-warning-search></elasticsearch-warning-search>
                    </div>
                    <table-elasticsearch-warning></table-elasticsearch-warning>
                </TabPane>
            </Tabs>
        </template>

    </div>
</template>

<script>
    import ElasticsearchWarningSearch from '../es/ElasticsearchWarningSearch'
    import TableElasticsearchWarning from '../es/TableElasticsearchWarning'

    export default {
        name: 'ElasticsearchWarning',
        components: {
            ElasticsearchWarningSearch,
            TableElasticsearchWarning
        },
        data(){
            return {
                id:'',
                accountId:'',
                accountTypeName:'',
                accountName:'',
                region:'',
                name:''
            }
        },
         methods:{
         	// 点击返回详情页
            ipAddress: function(){
                this.id = this.$route.query.id;
                this.accountId=this.$route.query.accountId;
                this.region=this.$route.query.region;
                this.accountTypeName=this.$route.query.accountTypeName;
                this.accountName=this.$route.query.accountName;
                this.name=this.$route.query.name;
                this.$router.push({path:'/monitor/elasticsearchDetail/',query: {id: this.id,accountId:this.accountId,region:this.region,accountTypeName:this.accountTypeName,accountName:this.accountName,name:this.name}});
            }
        }
    }
</script>

<style scoped>
    .elasticsearchWarning-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
    }
    .elasticsearchWarning-top
    {
        width: 100%;
        height: 32px;
        margin-bottom: 14px;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/es/ElasticsearchWarning.vue